import Vue from 'vue'

import { library } from '@fortawesome/fontawesome-svg-core'

// import {

// } from '@fortawesome/pro-regular-svg-icons'

import {
  faBars,
  faSearch,
  faStar,
  faSquare,
  faCheckSquare,
  faSortUp,
  faSortDown,
  faGripHorizontal,
  faGripVertical,
  faGripLines,
  faQuestionCircle,
  faChevronLeft,
  faChevronRight,
  faArrowsAltV,
  faArrowsAltH,
  faSortAmountDownAlt as faSortAmountDownAltSolid,
  faTimes,
  faLock,
} from '@fortawesome/pro-solid-svg-icons'

import {
  faCalendar,
  faCalendarPlus,
  faUsers,
  faDownload,
  faSignInAlt,
  faSignOutAlt,
  faFilePdf,
  faFileAlt,
  faSortAmountDownAlt as faSortAmountDownAltDuotone,
} from '@fortawesome/pro-duotone-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  faBars,
  faSearch,
  faCalendar,
  faCalendarPlus,
  faUsers,
  faStar,
  faDownload,
  faSquare,
  faCheckSquare,
  faSortUp,
  faSortDown,
  faGripHorizontal,
  faGripVertical,
  faGripLines,
  faQuestionCircle,
  faSignInAlt,
  faSignOutAlt,
  faChevronLeft,
  faChevronRight,
  faFilePdf,
  faFileAlt,
  faArrowsAltV,
  faArrowsAltH,
  faSortAmountDownAltSolid,
  faSortAmountDownAltDuotone,
  faTimes,
  faLock,
)

Vue.component('font-awesome-icon', FontAwesomeIcon)
